module.exports = __webpack_public_path__ + "app/principal/sellers-list-1N1V0ON_.html";